import { TFunc } from '@Translations/types';

// Maps legacy grade keys (as returned by the backend / stored in configs) to
// their new display names. Shared by Risk and Deterioration Model grades.
// Display-only: the underlying value is unchanged.
// Each branch uses a literal-string label so i18next-parser can extract the new keys.
export const getGradeLabel = (value: string, t: TFunc): string => {
	switch (value.toLowerCase()) {
		case 'extreme':
			return t('Critical');
		case 'high':
			return t('Concerning');
		case 'medium':
			return t('Moderate');
		case 'low':
			return t('Stable');
		case 'negligible':
			return t('Optimal');
		default:
			return value;
	}
};
